// extracted by mini-css-extract-plugin
export default {"root":"UnstyledAnchor_root__kO3p2"};